module.exports = __webpack_public_path__ + "img/bot.75d86a5f.svg";